import request from '../utils/request';

// 添加玉石鉴定分类
export const addCategory = (category) => {
  return request({
    url: '/jade-identification-category',
    method: 'post',
    data: category
  });
};

// 更新玉石鉴定分类
export const updateCategory = (category) => {
  return request({
    url: '/jade-identification-category',
    method: 'put',
    data: category
  });
};

// 删除玉石鉴定分类
export const deleteCategory = (categoryId) => {
  return request({
    url: `/jade-identification-category/${categoryId}`,
    method: 'delete'
  });
};

// 分页查询玉石鉴定分类
export const pageCategories = (page, pageSize, queryParams = {}) => {
  return request({
    url: '/jade-identification-category/page',
    method: 'get',
    params: {
      page,
      pageSize,
      ...queryParams
    }
  });
};

// 获取玉石鉴定分类详情
export const getCategoryDetail = (categoryId) => {
  return request({
    url: `/jade-identification-category/${categoryId}`,
    method: 'get'
  });
};

// 获取玉石鉴定分类树状结构
export const getCategoryTree = (status, name) => {
  return request({
    url: '/jade-identification-category/tree',
    method: 'get',
    params: {
      status,
      name
    }
  });
};

// 获取指定父分类下的子分类树状结构
export const getSubCategoryTree = (parentId, status) => {
  return request({
    url: `/jade-identification-category/subtree/${parentId}`,
    method: 'get',
    params: {
      status
    }
  });
};

// 获取全部玉石鉴定分类列表
export const listAllCategories = () => {
  return request({
    url: '/jade-identification-category/list',
    method: 'get'
  });
};

// 批量添加子分类
export const batchAddSubCategories = (parentId, categoryNames) => {
  return request({
    url: `/jade-identification-category/${parentId}/batch-add`,
    method: 'post',
    data: categoryNames
  });
};
